import React, { useCallback, useState } from 'react'
import { Placement } from '../popper'
import { MessageDescriptor, useIntl } from 'react-intl'
import { ActionButton } from '@contrast-security-inc/design-system-actions'
import { IconButtonProps } from '@contrast-security-inc/design-system-buttons'
import { IconSize } from '@contrast-security-inc/design-system-foundations'

export interface RenderDialogProps {
  isOpen: boolean
  closeDialog: () => void
  className?: string
}

export type DialogRenderer = (props: RenderDialogProps) => React.ReactNode

export interface ConfirmationActionProps {
  icon: IconButtonProps['Icon']
  iconTooltipMessage: MessageDescriptor
  renderDialog: DialogRenderer
  hideTooltip?: boolean
  iconTooltipPlacement?: Placement
  iconMetadata?: React.ReactNode
  size?: IconSize
  pendoId?: string
  isDisabled?: boolean
}

export const ConfirmationAction = (props: ConfirmationActionProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleActionClick = useCallback(() => setIsOpen(true), [])
  const handleCloseDialog = useCallback(() => setIsOpen(false), [])
  const { formatMessage } = useIntl()

  const {
    icon,
    iconTooltipMessage,
    iconTooltipPlacement,
    renderDialog,
    iconMetadata,
    pendoId,
    hideTooltip = false,
    size = 'sm',
    isDisabled,
    ...rest
  } = props

  const tooltipMessage = formatMessage(iconTooltipMessage)

  return (
    <React.Fragment>
      <ActionButton
        {...rest}
        TooltipProps={{
          enabled: !hideTooltip,
          placement: iconTooltipPlacement,
          body: tooltipMessage
        }}
        IconButtonProps={{
          Icon: icon,
          size,
          'aria-label': tooltipMessage
        }}
        onClick={handleActionClick}
        metadata={iconMetadata}
        testId={iconTooltipMessage.id}
        data-pendo={pendoId}
        isDisabled={isDisabled}
      />
      {isOpen && renderDialog({ isOpen, closeDialog: handleCloseDialog })}
    </React.Fragment>
  )
}
